export const authPath = process.env.VUE_APP_AUTH_URL;
export const fileServer =
  process.env.VUE_APP_SERVER_APIURL ||
  (window.location.origin.endsWith('/') ? window.location.origin.slice(0, -1) : window.location.origin);

export const equipServer = process.env.VUE_APP_SERVER_APIURLEQUIP;
// export const fileServer = process.env.VUE_APP_SERVER_APIURL // api地址

// console.log(process.env.VUE_APP_SERVER_APIURL)

/**
 * @角色组权限递归菜单
 */
export function getRoleMenu(data) {
  const res = [];
  //@ 找出所有根结点
  for (const item of data) {
    if (item.parentid == '00000000-0000-0000-0000-000000000000') {
      let mainObj = {
        id: item.id,
        label: item.title,
        parentid: '00000000-0000-0000-0000-000000000000',
        sort: item.sort,
      };
      mainObj.children = getMenuNode(item.id);

      res.push(mainObj);
    }
  }
  //@ 传入根结点id 递归查找所有子节点
  function getMenuNode(id) {
    const node = [];
    for (const item of data) {
      if (item.parentid.toLowerCase() === id) {
        item.children = getMenuNode(item.id);
        node.push({
          id: item.id,
          label: item.title,
          parentid: item.parentid,
          rolelevel: null,
          name: item.name,
          sort: item.sort,
        });
      }
    }
    if (node.length === 0) return;
    return node;
  }

  return res;
}

export function treeFind(tree, func) {
  for (const data of tree) {
    if (func(data)) return data;
    if (data.children) {
      const res = treeFind(data.children, func);
      if (res) return res;
    }
  }
  return null;
}

export function treeData(source, id = 'id', parentId = 'parentId', children = 'children') {
  let cloneData = JSON.parse(JSON.stringify(source));
  return cloneData.filter((father) => {
    let branchArr = cloneData.filter((child) => {
      child.meta = {
        title: child.title,
        remixIcon: child.remixIcon ? child.remixIcon : 'bim',
      };
      //return father[id] === child[parentId]
      return father[id].toLowerCase() === child[parentId].toLowerCase();
    });
    branchArr.length > 0 ? (father[children] = branchArr) : '';
    return father[parentId] == '00000000-0000-0000-0000-000000000000';
  });
}

/**
 * @description 树形数据转数组
 * @param {*} source
 * @param {*} children
 * @returns
 */
export function tree2List(source, children = 'children') {
  let result = [];
  let cloneData = JSON.parse(JSON.stringify(source));
  cloneData.map((item) => {
    if (Array.isArray(item[children])) {
      result = [...result, item, ...tree2List(item[children], children)];
      delete item[children];
    } else {
      result.push(item);
    }
  });
  return result;
}

/**
 * @description 格式化时间
 * @param time
 * @param cFormat
 * @returns {string|null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  let date;
  if (typeof time === 'object') {
    date = time;
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time);
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  return format.replace(/{([ymdhisa])+}/g, (result, key) => {
    let value = formatObj[key];
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value];
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
}

/**
 * @description 格式化时间
 * @param time
 * @param option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000;
  } else {
    time = +time;
  }
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return '刚刚';
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前';
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前';
  } else if (diff < 3600 * 24 * 2) {
    return '1天前';
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分';
  }
}

/**
 * @description 将url请求参数转为json格式
 * @param url
 * @returns {{}|any}
 */
export function paramObj(url) {
  const search = url.split('?')[1];
  if (!search) {
    return {};
  }
  return JSON.parse(
    '{"' +
      decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"')
        .replace(/\+/g, ' ') +
      '"}'
  );
}

/**
 * @description 父子关系的数组转换成树形结构数据
 * @param data
 * @returns {*}
 */
export function translateDataToTree(data) {
  const parent = data.filter((value) => value.parentId === 'undefined' || value.parentId == null);
  const children = data.filter((value) => value.parentId !== 'undefined' && value.parentId != null);
  const translator = (parent, children) => {
    parent.forEach((parent) => {
      children.forEach((current, index) => {
        if (current.parentId === parent.id) {
          const temp = JSON.parse(JSON.stringify(children));
          temp.splice(index, 1);
          translator([current], temp);
          typeof parent.children !== 'undefined' ? parent.children.push(current) : (parent.children = [current]);
        }
      });
    });
  };
  translator(parent, children);
  return parent;
}

/**
 * @description 树形结构数据转换成父子关系的数组
 * @param data
 * @returns {[]}
 */
export function translateTreeToData(data) {
  const result = [];
  data.forEach((item) => {
    const loop = (data) => {
      result.push({
        id: data.id,
        name: data.name,
        parentId: data.parentId,
      });
      const child = data.children;
      if (child) {
        for (let i = 0; i < child.length; i++) {
          loop(child[i]);
        }
      }
    };
    loop(item);
  });
  return result;
}

/**
 * @description 10位时间戳转换
 * @param time
 * @returns {string}
 */
export function tenBitTimestamp(time) {
  const date = new Date(time * 1000);
  const y = date.getFullYear();
  let m = date.getMonth() + 1;
  m = m < 10 ? '' + m : m;
  let d = date.getDate();
  d = d < 10 ? '' + d : d;
  let h = date.getHours();
  h = h < 10 ? '0' + h : h;
  let minute = date.getMinutes();
  let second = date.getSeconds();
  minute = minute < 10 ? '0' + minute : minute;
  second = second < 10 ? '0' + second : second;
  return y + '年' + m + '月' + d + '日 ' + h + ':' + minute + ':' + second; //组合
}

/**
 * @description 13位时间戳转换
 * @param time
 * @returns {string}
 */
export function thirteenBitTimestamp(time) {
  const date = new Date(time / 1);
  const y = date.getFullYear();
  let m = date.getMonth() + 1;
  m = m < 10 ? '' + m : m;
  let d = date.getDate();
  d = d < 10 ? '' + d : d;
  let h = date.getHours();
  h = h < 10 ? '0' + h : h;
  let minute = date.getMinutes();
  let second = date.getSeconds();
  minute = minute < 10 ? '0' + minute : minute;
  second = second < 10 ? '0' + second : second;
  return y + '年' + m + '月' + d + '日 ' + h + ':' + minute + ':' + second; //组合
}

/**
 * @description 获取随机id
 * @param length
 * @returns {string}
 */
export function uuid() {
  return S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4();
}
function S4() {
  return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
}
/**
 * @description m到n的随机数
 * @param m
 * @param n
 * @returns {number}
 */
export function random(m, n) {
  return Math.floor(Math.random() * (m - n) + n);
}

/**
 * @description addEventListener
 * @type {function(...[*]=)}
 */
export const on = (function() {
  return function(element, event, handler, useCapture = false) {
    if (element && event && handler) {
      element.addEventListener(event, handler, useCapture);
    }
  };
})();

/**
 * @description removeEventListener
 * @type {function(...[*]=)}
 */
export const off = (function() {
  return function(element, event, handler, useCapture = false) {
    if (element && event) {
      element.removeEventListener(event, handler, useCapture);
    }
  };
})();
/**
 * 实现深克隆---对象/数组
 * @param { Array / Object } target 需要复制的数组或对象
 */
export const deepCopy = (target) => {
  // 判断拷贝的数据类型
  let result;
  let targetType = _checkedType(target);
  if (targetType === 'Object') {
    result = {};
  } else if (targetType === 'Array') {
    result = [];
  } else {
    return target;
  }
  // 遍历目标数据
  for (let i in target) {
    let value = target[i];
    // 判断目标结构里的每一值是否存在对象/数组
    if (_checkedType(value) === 'Object' || _checkedType(value) === 'Array') {
      result[i] = deepCopy(value);
    } else {
      result[i] = value;
    }
  }
  return result;
};

// 定义检测数据类型的功能函数
const _checkedType = (target) => {
  return Object.prototype.toString.call(target).slice(8, -1);
};
/**
 * @description: 把B对象 赋值给 A对象 (根据键值名相等的原则)  彭妙培
 * @param {*}
 * @return {*}arrANew
 */
export const listAssign = (arrA, arrB) => {
  let arrANew = JSON.parse(JSON.stringify(arrA));
  let arrBNew = JSON.parse(JSON.stringify(arrB));

  for (var Akey in arrANew) {
    for (var Bkey in arrBNew) {
      if (Akey.toLowerCase() == Bkey.toLowerCase()) {
        arrANew[Akey] = arrBNew[Bkey];
      }
    }
  }
  return arrANew;
  // Object.assign

  //   Object.keys(arrA).forEach((key) => {
  //     arrA[key]= arrB[key] || arrA[key]
};
